/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const LinkedResourceRef: core.serialization.ObjectSchema<
    serializers.LinkedResourceRef.Raw,
    Truvity.LinkedResourceRef
> = core.serialization.object({
    resourceId: core.serialization.property('resource_id', core.serialization.string()),
});

export declare namespace LinkedResourceRef {
    export interface Raw {
        resource_id: string;
    }
}
